var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.25V12H24.25V25C24.25 25.4872 24.0853 25.8858 23.7354 26.2363C23.3862 26.5861 22.9885 26.7506 22.501 26.75H7.5C7.01297 26.75 6.61504 26.5856 6.26562 26.2363C5.95967 25.9304 5.79453 25.5864 5.75781 25.1777L5.75 24.999V5C5.75 4.51323 5.91448 4.11522 6.26465 3.76562C6.57164 3.45915 6.91539 3.2946 7.32227 3.25781L7.50098 3.25H15.5ZM13.6562 17.8457L11.0312 15.2207L8.18945 18.0625L13.6875 23.5605L21.8105 15.4375L18.9375 12.5645L13.6562 17.8457ZM17.1895 3.25L24.25 10.3105V11.9395L15.5605 3.25H17.1895Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualTasks);
export default __webpack_public_path__ + "static/media/Manual Tasks.d4ea3b73206a143552bc998bebba326f.svg";
export { ForwardRef as ReactComponent };